export default __webpack_public_path__ + "static/media/ml.371403f0.svg";